import React from 'react';
import { Box, Alert, Typography } from '@mui/material';
import SubjectDetails from '../SubjectDetails';

const SubjectPreviewWrapper: React.FC = () => {
    return (
        <Box>
            <Alert
                severity="info"
                sx={{
                    borderRadius: 0,
                    mb: 0,
                    borderBottom: '1px solid #e0e0e0',
                    justifyContent: 'center',
                    '& .MuiAlert-message': { width: '100%', textAlign: 'center' }
                }}
            >
                <Typography variant="body2" component="span" fontWeight="bold">
                    Student View Preview Mode:
                </Typography>
                {' '} You are viewing this subject as a student. Progress is not saved.
            </Alert>
            <SubjectDetails preview={true} />
        </Box>
    );
};

export default SubjectPreviewWrapper;
